import { createContext } from "react";
import { Stage } from "../lusca-search-api/generated-src";

const OrderIdContext = createContext("");

const StageContext = createContext<Stage>(null as never);

export { OrderIdContext, StageContext };
